import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SpeakerCards from '../speakerCards/speakerCards';
import infiniteScroll from "@/components/infinite-scroll";
import PageState from './store/state';
import moduleStore from './store/searchByname';
@Component({
  components: {
    SpeakerCards
  },
  directives:{
    infiniteScroll
  }
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class SearchByname extends Vue{
  state = new PageState();
  speakerResults = null;
  keyword = '';
  pageSize =16;
  pageNum = 1;
  totalPages = 1;
  isLoading = false;
  @Prop()templateSpeaker: any;//本次模版的发音人speaker字段
  mounted(){
    (this.$refs.searchInputRef as any).focus();
  }
  loadMore(){
    if(this.pageNum>=this.totalPages){
      return;
    }
    this.pageNum++;
    this.getSpeakerBySearchFn(true)
  }
  /**根据条件查询发音人信息-明智接口 */
  getSpeakerBySearchFn(isLoadMore=false){
    if(!isLoadMore){//更换了查询条件
      this.pageNum =1;
    }
    let queryParam:any ={
      pageNum:this.pageNum,
      pageSize:this.pageSize,
      keyword:this.keyword
    }
    this.isLoading = true;
    this.$http("getSpeakerBySearch",queryParam).then(res => {
        let {totalPages,results} = res.data;
        this.totalPages = totalPages;
        //将风格中的第一个发音人作为默认发音人数据
        if(results.length>0){
          results = results.map((item,index)=>{
            return {
              ...item,
              defaultSpeaker:item.speakerEmotionCacheVOList[0]
            }
          })
        }
        if(!isLoadMore){
          this.speakerResults = results;
        }else{
          this.speakerResults = this.speakerResults.concat(results);
        }
        this.isLoading = false;
    })
  }
  search(){
    this.getSpeakerBySearchFn();
  }
  clearKeyword(){
    let  card2Ref = this.$refs.speakerCards2;
    //若有试听,取消
    card2Ref && (card2Ref as any).cancelListen();
    this.$emit('hideSearchByName');
  }
  setCurrentSpeaker(speaker){
    this.$emit('setCurrentSpeaker',speaker)
  }
  byNameCancelListen(){
     //若有试听,取消
     let  card2Ref = this.$refs.speakerCards2;
    card2Ref && (card2Ref as any).cancelListen();
  }
}